/**
 * @Desc: 收货信息管理静态数据
 * @Date: 2021-11-02 10:33
 * @Last Modified by: p_yufangyin
 * @Last Modified time: 2021-11-02 10:33
 */
export const FIELD_SOURCE = [
  {
    name: 'supplier_code',
    label: '供应商',
    type: 'select',
    options: [],
    span: 6,
  },
];

export const ADDRESS_COLUMS = [
  {
    title: '供应商',
    dataIndex: 'supplier_name',
  },
  {
    title: '收货地址',
    dataIndex: 'address',
    ellipsis: true,
    width: 320,
  },
  {
    title: '联系人',
    dataIndex: 'user',
  },
  {
    title: '联系电话',
    dataIndex: 'tel',
  },
  {
    title: '更新时间',
    dataIndex: 'update_time',
  },
  {
    title: '修改人',
    dataIndex: 'operator',
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    fixed: 'right',
  },
];
